// Fetch YouTube titles dynamically
document.querySelectorAll('.howto-video-item').forEach((item) => {
  const videoId = item.dataset.youtubeId;
  const titleEl = item.querySelector('.video-title');
  if (!videoId || !titleEl) return;

  fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`)
    .then((response) => {
      if (!response.ok) throw new Error('Failed to fetch title');
      return response.json();
    })
    .then((data) => {
      titleEl.textContent = data.title || 'Untitled Video';
    })
    .catch(() => {
      titleEl.textContent = '';
    });
});

document.addEventListener('DOMContentLoaded', function () {
   // Set first list items as active
   document.querySelector('.explore-2 ul li:first-child')?.classList.add('active');
   document.querySelector('.explore-2-mobile ul li:first-child')?.classList.add('active');

   // Desktop image setup
   let firstDesktopImg = document.querySelector('.explore-2 ul li:first-child img');
   if (firstDesktopImg) {
      let newSrc = firstDesktopImg.getAttribute('src');
      console.log(newSrc);
      let explore1Img = document.querySelector('.explore-1 img');
      if (explore1Img) explore1Img.setAttribute('src', newSrc);
   }

   // Mobile image setup
   let firstMobileImg = document.querySelector('.explore-inner-mobile ul li:first-child img');
   if (firstMobileImg) {
      let newSrc = firstMobileImg.getAttribute('src');
      let explore1MobileImg = document.querySelector('.explore-1-mobile img');
      if (explore1MobileImg) explore1MobileImg.setAttribute('src', newSrc);
   }

   // Mobile content setup
   let firstMobileLi = document.querySelector('.explore-inner-mobile ul li:first-child');
   if (firstMobileLi) {
      let data = firstMobileLi.innerHTML;
      let contentP = document.querySelector('.explore-inner-mobile .inner-accordion-explore p');
      if (contentP) contentP.innerHTML = data;
   }

   // Click event for desktop list
   document.querySelectorAll('.explore-2 ul li').forEach(function (item) {
      item.addEventListener('click', function () {
         document.querySelectorAll('.explore-2 ul li').forEach((li) => li.classList.remove('active'));
         this.classList.add('active');

         let newSrc = this.querySelector('img')?.getAttribute('src');
         console.log(newSrc);
         let explore1Img = document.querySelector('.explore-1 img');
         if (explore1Img && newSrc) explore1Img.setAttribute('src', newSrc);
      });
   });

   // Click event for mobile list
   document.querySelectorAll('.content-accordion-explore ul li').forEach(function (item) {
      item.addEventListener('click', function () {
         document.querySelectorAll('.content-accordion-explore ul li').forEach((li) => li.classList.remove('active'));
         this.classList.add('active');

         let newSrc = this.querySelector('img')?.getAttribute('src');
         let explore1MobileImg = document.querySelector('.explore-1-mobile img');
         if (explore1MobileImg && newSrc) explore1MobileImg.setAttribute('src', newSrc);

         let data = this.innerHTML;
         let contentP = document.querySelector('.explore-inner-mobile .inner-accordion-explore p');
         if (contentP) contentP.innerHTML = data;

         let explore2Mobile = document.querySelector('.explore-2-mobile');
         if (explore2Mobile) explore2Mobile.classList.remove('active');
      });
   });
});

// Desktop FAQ Script Code
document.addEventListener('DOMContentLoaded', function () {
   const accordions = document.querySelectorAll('.gwt-ft-faq-accordion');

   accordions.forEach((acc) => {
      const trigger = acc.querySelector('p');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
         acc.classList.toggle('active');
      });
   });
});

document.addEventListener('DOMContentLoaded', function () {
   // Initialize Swiper instances
   let swiperInstances = {};

   // Desktop Swipers with autoHeight enabled
   swiperInstances.faqDesktop = new Swiper('.swiper-faq-desktop', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: false,
      autoHeight: true, // KEY FIX: Dynamically adjust height
      pagination: {
         el: '.gwt-pagination-faq-desktop',
         type: 'fraction',
         formatFractionCurrent: function (number) {
            return number;
         },
         formatFractionTotal: function (number) {
            return number;
         },
      },
      navigation: {
         nextEl: '.gwt-next-faq-desktop',
         prevEl: '.gwt-prev-faq-desktop',
      },
   });

   swiperInstances.blogsDesktop = new Swiper('.swiper-blogs-desktop', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: false,
      autoHeight: true, // KEY FIX: Dynamically adjust height
      pagination: {
         el: '.gwt-pagination-blogs-desktop',
         type: 'fraction',
         formatFractionCurrent: function (number) {
            return number;
         },
         formatFractionTotal: function (number) {
            return number;
         },
      },
      navigation: {
         nextEl: '.gwt-next-blogs-desktop',
         prevEl: '.gwt-prev-blogs-desktop',
      },
      breakpoints: {
         768: {
            slidesPerView: 1,
            spaceBetween: 20,
         },
      },
   });

   swiperInstances.reviewsDesktop = new Swiper('.swiper-reviews-desktop', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: false,
      autoHeight: true, // KEY FIX: Dynamically adjust height
      pagination: {
         el: '.gwt-pagination-reviews-desktop',
         type: 'fraction',
         formatFractionCurrent: function (number) {
            return number;
         },
         formatFractionTotal: function (number) {
            return number;
         },
      },
      navigation: {
         nextEl: '.gwt-next-reviews-desktop',
         prevEl: '.gwt-prev-reviews-desktop',
      },
      breakpoints: {
         768: {
            slidesPerView: 1,
            spaceBetween: 20,
         },
      },
   });


   // Desktop Swipers with autoHeight enabled
   swiperInstances.faqDesktop = new Swiper('.swiper-about-desktop', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: false,
      autoHeight: true, // KEY FIX: Dynamically adjust height
      pagination: {
         el: '.gwt-pagination-about-desktop',
         type: 'fraction',
         formatFractionCurrent: function (number) {
            return number;
         },
         formatFractionTotal: function (number) {
            return number;
         },
      },
      navigation: {
         nextEl: '.gwt-next-about-desktop',
         prevEl: '.gwt-prev-about-desktop',
      },
   });

   // Mobile Swipers (within accordions) with autoHeight
   const faqSwiper = new Swiper('.gwt-accordion-item[data-accordion="faq"] .swiper', {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      autoHeight: true, // Also apply to mobile
      pagination: {
         el: '.gwt-pagination-faq',
         type: 'fraction',
      },
      navigation: {
         nextEl: '.gwt-next-faq',
         prevEl: '.gwt-prev-faq',
      },
   });

   const blogsSwiper = new Swiper('.gwt-accordion-item[data-accordion="blogs"] .swiper', {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      autoHeight: true, // Also apply to mobile
      pagination: {
         el: '.gwt-pagination-blogs',
         type: 'fraction',
      },
      navigation: {
         nextEl: '.gwt-next-blogs',
         prevEl: '.gwt-prev-blogs',
      },
      breakpoints: {
         480: {
            slidesPerView: 2,
            spaceBetween: 16,
         },
      },
   });

   const reviewsSwiper = new Swiper('.gwt-accordion-item[data-accordion="reviews"] .swiper', {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      autoHeight: true, // Also apply to mobile
      pagination: {
         el: '.gwt-pagination-reviews',
         type: 'fraction',
      },
      navigation: {
         nextEl: '.gwt-next-reviews',
         prevEl: '.gwt-prev-reviews',
      },
      breakpoints: {
         577: {
            slidesPerView: 2,
            spaceBetween: 16,
         },
      },
   });

   // Desktop Tab Switching
   const tabItems = document.querySelectorAll('.gwt-yuva-tab-item');
   const tabPanels = document.querySelectorAll('.gwt-tab-panel');

   tabItems.forEach((tab) => {
      tab.addEventListener('click', function () {
         const tabName = this.getAttribute('data-tab');

         // Remove active class from all tabs
         tabItems.forEach((t) => t.classList.remove('active'));

         // Add active class to clicked tab
         this.classList.add('active');

         // Hide all panels
         tabPanels.forEach((panel) => panel.classList.remove('active'));

         // Show corresponding panel
         const activePanel = document.querySelector(`.gwt-tab-panel[data-panel="${tabName}"]`);
         if (activePanel) {
            activePanel.classList.add('active');
         }

         // Update swiper height after tab change
         setTimeout(function () {
            if (tabName === 'faq' && swiperInstances.faqDesktop) {
               swiperInstances.faqDesktop.updateAutoHeight(300);
            } else if (tabName === 'blogs' && swiperInstances.blogsDesktop) {
               swiperInstances.blogsDesktop.updateAutoHeight(300);
            } else if (tabName === 'reviews' && swiperInstances.reviewsDesktop) {
               swiperInstances.reviewsDesktop.updateAutoHeight(300);
            }
         }, 100);
      });
   });

   // Mobile Accordion
   const accordionItems = document.querySelectorAll('.gwt-accordion-item');

   accordionItems.forEach((item) => {
      const header = item.querySelector('.gwt-accordion-header');
      const toggle = item.querySelector('.gwt-accordion-toggle');

      toggle.addEventListener('click', function (e) {
         e.preventDefault();
         const isActive = item.classList.contains('active');

         // Close all accordion items
         accordionItems.forEach((accItem) => {
            accItem.classList.remove('active');
         });

         // Open clicked item if it wasn't active
         if (!isActive) {
            item.classList.add('active');
         }
      });
   });
});

document.addEventListener('DOMContentLoaded', function () {

  // ✅ Only run on screens 768px and above
  if (window.innerWidth < 768) return;

  const modal = document.getElementById('videoModal');
  const iframe = document.getElementById('videoIframe');
  const closeBtn = modal.querySelector('.video-close');
  const overlay = modal.querySelector('.video-modal-overlay');

  document.querySelectorAll('.howto-video-item').forEach(item => {
    item.addEventListener('click', function () {
      const videoId = this.dataset.youtubeId;

      iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  function closeModal() {
    modal.classList.remove('active');
    iframe.src = ''; // stop video
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
});


document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('videoModalMobile');
  const iframe = document.getElementById('videoIframeMobile');
  const closeBtn = modal.querySelector('.video-close');
  const overlay = modal.querySelector('.video-modal-overlay');

  document.querySelectorAll('.howto-video-item.mobile').forEach(item => {
    item.addEventListener('click', function () {
      const videoId = this.dataset.youtubeId;

      iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  function closeModal() {
    modal.classList.remove('active');
    iframe.src = ''; // stop video
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
});